export default "__VITE_ASSET__BAdgAnlI__"